import { AbstractControl, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function DateLessThanValidator(
  dateField1: string,
  dateField2: string,
  canBeEqual = true
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const date1 = c.get(dateField1) ? c.get(dateField1).value : null;
    const date2 = c.get(dateField2) ? c.get(dateField2).value : null;

    if (date1 === null && (date2 === null || date2 !== null)) {
      return null;
    }

    if (date1 !== null && date2 === null) {
      return null;
    }

    if ((date1 !== null || date1 !== '') && (date2 !== null || date2 !== '')) {
      if (
        (canBeEqual && moment(date1).isAfter(moment(date2))) ||
        (!canBeEqual && !moment(date1).isBefore(moment(date2)))
      ) {
        return { startDateBeforeEndDate: true };
      }
    }

    return null;
  };
}

export function MustHaveStartDateIfEndDateValidator(
  dateField1: string,
  dateField2: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const date1 = c.get(dateField1) ? c.get(dateField1).value : null;
    const date2 = c.get(dateField2) ? c.get(dateField2).value : null;

    if ((date1 === null || date1 === '') && (date2 === null || date2 === '')) {
      return null;
    }

    if ((date1 === null || date1 === '') && (date2 !== null || date2 !== '')) {
      return { requiredStartDate: true };
    }

    return null;
  };
}

export function StartAndEndDateRequiredValidator(
  dateField1: string,
  dateField2: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const date1 = c.get(dateField1) ? c.get(dateField1).value : null;
    const date2 = c.get(dateField2) ? c.get(dateField2).value : null;
    const missingDate1 = !date1 ? true : false;
    const missingDate2 = !date2 ? true : false;
    let result = { nullStartDate: false, nullEndDate: false };

    if (missingDate1) {
      result.nullStartDate = true;
    }

    if (missingDate2) {
      result.nullEndDate = true;
    }

    if (result.nullStartDate || result.nullEndDate) {
      return result;
    }

    return null;
  };
}
